type SignupProgressBarProps = {
  currentStepIndex: number;
  totalSteps: number;
};

export const SignupProgressBar = ({ currentStepIndex, totalSteps }: SignupProgressBarProps) => {
  const safeTotal = Math.max(totalSteps, 1);
  const safeIndex = Math.min(Math.max(currentStepIndex, 0), safeTotal - 1);
  const progress = ((safeIndex + 1) / safeTotal) * 100;

  return (
    <div
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={safeTotal}
      aria-valuenow={safeIndex + 1}
      aria-label={`Etapa ${safeIndex + 1} de ${safeTotal}`}
      className="fixed inset-x-0 top-0 z-20 h-1 bg-gray-200"
    >
      <div
        className="h-full bg-black transition-[width] duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
